/**
 * Container for an Link Group View component.
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { Collection, Screen, ScreenSection, DevicePlatform } from '../../api/types'
import { RedeemedBundles } from '../../bundles/types'
import { validateBundleCoupon } from '../../api/actions'

export interface OwnProps {
	screen: Screen
	section: ScreenSection
	collectionId?: number
	closeModal?: () => void
	isInsideModal: boolean
}

export interface Props extends OwnProps {
	collection?: Collection
	collectionItemsIds: number[]
	redeemedBundles: RedeemedBundles
}

export interface Actions {
	validateBundleCoupon: (args: {
		devicePlatform: DevicePlatform
		coupon: string
		id: number
		expireAt?: number
	}) => void
}

const mapStateToProps = (state: RootStoreState, ownProps: OwnProps): Props => {
	const { collectionId } = ownProps
	const collectionObject = collectionId ? state.collectionlist.collectionDetails.get(collectionId) : undefined
	const collectionItems = collectionId ? state.collectionlist.collectionItems.get(collectionId) : undefined
	const collectionItemsIds = (collectionItems?.items?.map(item => item.item_id).filter(Boolean) as number[]) || []

	return {
		...ownProps,
		collection: collectionObject?.details,
		collectionItemsIds,
		redeemedBundles: state.bundles.redeemedBundles,
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	validateBundleCoupon: args => dispatch(validateBundleCoupon.started(args)),
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
